/// <reference path="_references.ts"/>

module App.Forms {
	export interface FormList {
		id: number;
		name: string;
		description: string;
	}

	export interface Form extends FormList {
		customer_signature: keyof typeof SignatureType;
		tech_signature: keyof typeof SignatureType;
		elements: FormElement[];
		read_only: boolean;
		title: string;
	}

	export enum SignatureType {
		NONE,
		ALLOW,
		REQUIRED,
	}

	export enum FormElementType {
		Checkbox,
		CheckList,
		Dropdown,
		Header,
		MultiSelect,
		Number,
		StaticText,
		Text,
		TextArea,
		PassFail,
	}

	export interface FormElement {
		id?: number;
		type: keyof typeof FormElementType;
		name: string;
		read_only: boolean;

		size?: 1|2|3;
		required?: boolean;
		help_text?: string;
		placeholder?: string;
		show_name?: boolean;
		min?: number;
		max?: number;
		text?: string;
		options?: string[];
		columns?: string[];
	}

	export interface FormAnswer {
		id: number;
		answer?: string;
		description?: string;
		selected?: string[];
		element: number;
		images: FormAnswerImage[];
	}

	export interface FormAnswerImage {
		id: number;
		url: string;
	}

	export interface FormInstanceList {
		id: number;
		created: Date;
		version: FormList;
	}

	export interface FormInstance extends FormInstanceList {
		version: Form;
		answers: FormAnswer[];
		service_request: number|{id: number}|null;
		serviceable_item: number|{id: number}|null;
		customer_signature?: string;
		tech_signature?: string;
	}
}
